import { render, staticRenderFns } from "./HorizontalView.vue?vue&type=template&id=5658e464&scoped=true"
import script from "./HorizontalView.vue?vue&type=script&lang=js"
export * from "./HorizontalView.vue?vue&type=script&lang=js"
import style0 from "./HorizontalView.vue?vue&type=style&index=0&id=5658e464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5658e464",
  null
  
)

export default component.exports